import { Link } from "react-router-dom";
import "../App.css";

export default function PrivacyPolicy() {
  return (
    <div className="inkflow-page ink-legal-page">
      <nav className="ink-nav s">
        <Link to="/" className="ink-logo" data-testid="logo-link">
          INK<span>FLOW</span>
        </Link>
        <Link to="/" className="ink-nav-cta">Back to home</Link>
      </nav>

      <main className="ink-legal-wrap">
        <div className="ink-eyebrow" style={{ marginBottom: 24 }}>
          <div className="ink-eyebrow-line"></div>
          <span>Legal</span>
        </div>
        <h1 className="ink-legal-title">Privacy Policy</h1>
        <p className="ink-legal-meta">Last updated: May 13, 2026</p>

        <section className="ink-legal-section">
          <h2>1. Who we are</h2>
          <p>
            This website is operated by <strong>Inkflow / Agency Escape</strong>,
            located at <strong>Bergekouter 132, 9300 Aalst, Belgium</strong>,
            registered under VAT number <strong>BE1005105981</strong>.
          </p>
          <p>
            For any privacy-related question you can reach us via the contact
            form or our Instagram account (@jelle.agencyescape).
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>2. What data we collect</h2>
          <p>We only collect personal data you actively give us:</p>
          <ul>
            <li>Your email address when you request the free ebook.</li>
            <li>Your name, email, phone number and answers when you book a discovery call.</li>
            <li>Technical data automatically collected by our infrastructure (IP address, browser type, referrer) for security and analytics.</li>
          </ul>
        </section>

        <section className="ink-legal-section">
          <h2>3. Why we process your data</h2>
          <ul>
            <li>To deliver the requested ebook or service (legal basis: performance of a contract / pre-contract).</li>
            <li>To contact you about your application or send relevant updates (legal basis: legitimate interest).</li>
            <li>To comply with Belgian and EU legal obligations.</li>
            <li>To improve our website and offering through aggregated analytics.</li>
          </ul>
        </section>

        <section className="ink-legal-section">
          <h2>4. Who has access to your data</h2>
          <p>
            Your data is stored on secure infrastructure and is only accessible
            to Inkflow / Agency Escape and the technical service providers strictly
            needed to deliver the service (hosting, CRM via GoHighLevel, calendar
            booking). We do not sell or rent your data.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>5. How long we keep your data</h2>
          <p>
            Lead data is kept for as long as you want to remain in our database
            and a maximum of 5 years from the last interaction, unless legal
            obligations require longer retention (e.g. accounting records).
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>6. Your rights (GDPR)</h2>
          <p>
            Under the General Data Protection Regulation (Regulation (EU) 2016/679)
            and the Belgian Data Protection Act, you have the right to:
          </p>
          <ul>
            <li>Request access to the personal data we hold about you.</li>
            <li>Request correction or deletion of your data.</li>
            <li>Object to or restrict certain processing activities.</li>
            <li>Withdraw your consent at any time.</li>
            <li>Lodge a complaint with the Belgian Data Protection Authority
              (<a href="https://www.gegevensbeschermingsautoriteit.be" target="_blank" rel="noopener noreferrer">gegevensbeschermingsautoriteit.be</a>).</li>
          </ul>
          <p>To exercise any of these rights, contact us via Instagram or the contact form.</p>
        </section>

        <section className="ink-legal-section">
          <h2>7. Cookies</h2>
          <p>
            We use essential cookies to make the site work and may use functional
            cookies to remember your preferences. We do not use advertising
            cookies. You can disable cookies via your browser settings.
          </p>
        </section>

        <section className="ink-legal-section">
          <h2>8. Changes to this policy</h2>
          <p>
            We may update this Privacy Policy from time to time. The latest
            version will always be available on this page with the "Last updated"
            date at the top.
          </p>
        </section>

        <Link to="/" className="btn-gold ink-legal-back" data-testid="legal-back-btn">
          <span>← Back to home</span>
        </Link>
      </main>
    </div>
  );
}
